import type { IconSvgObject } from './types';

const LoaderCircleIcon: IconSvgObject = [
  ["path", { d: "M21.9961 12C21.9961 17.5228 17.5189 22 11.9961 22C6.47325 22 1.99609 17.5228 1.99609 12C1.99609 6.47715 6.47325 2 11.9961 2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }]
];

export default LoaderCircleIcon;
